import { GalleryDialog } from './GalleryDialog';
import React, { Fragment, useCallback, useMemo, useRef, useState } from 'react';
import ImageUploading from 'react-images-uploading';
import { GalleryContents } from './GalleryContents';
import { GalleryItem } from './types';
import { CropperMode } from 'components/CoverImageControl/types';

export interface GalleryProps {
    value: GalleryItem[];
    onChange: (value: GalleryItem[]) => void;
    hideBannerSettings?: boolean;
    aspectRatio?: number;
    mode?: CropperMode;
    cloudinaryImages?: boolean;
}

export const Gallery = (props: GalleryProps) => {
    const { value, onChange, hideBannerSettings, aspectRatio, mode, cloudinaryImages } = props;

    const [editedItemId, setEditedItemId] = useState<number | null>(null);

    // const closeImageDialog = useCallback(() => setEditedItemId(null), [setEditedItemId]);

    const handleImageAdd = useCallback((images) => {
        onChange(images);
        const uncroppedImageIndex = images.findIndex((image: GalleryItem) => !image.croppedArea && !image.imageId);
        setTimeout(() => setEditedItemId(uncroppedImageIndex === -1 ? null : uncroppedImageIndex), 0);
    }, [onChange, setEditedItemId])

    const handleImageSave = useCallback(
        (galleryItem: GalleryItem) => {
            const updatedValue = [...value];
            updatedValue[editedItemId] = {
                ...updatedValue[editedItemId],
                ...galleryItem,
            };
            setEditedItemId(null);
            handleImageAdd(updatedValue);
        },
        [editedItemId, value, onChange, setEditedItemId],
    );

    const previewRefs = useRef(new Map());

    const handlePreviewRef = useCallback(
        (ref: HTMLDivElement, index: number) => {
            previewRefs.current.set(index, ref);
        },
        [previewRefs],
    );

    const currentPreviewRef = useMemo(() => {
        return previewRefs.current.get(editedItemId);
    }, [previewRefs, editedItemId]);

    const editedItem = editedItemId !== null ? value[editedItemId] : null;

    return (
        <Fragment>
            <div>
                <ImageUploading multiple value={value} onChange={handleImageAdd}  maxNumber={20}>
                    {uploader => (
                        <GalleryContents 
                            onEdit={setEditedItemId}
                            onPreviewRef={handlePreviewRef} 
                            aspectRatio={aspectRatio} 
                            cloudinaryImages={cloudinaryImages}
                            {...uploader} 
                        />
                    )}
                </ImageUploading>
            </div>

            {editedItem && (
                <GalleryDialog
                    image={editedItem}
                    previewRef={currentPreviewRef}
                    hideBannerSettings={hideBannerSettings}
                    aspectRatio={aspectRatio}
                    mode={mode}
                    onSave={handleImageSave}
                />
            )}
        </Fragment>
    );
};
